<template>
  <div class="my-play-hist-template" theme>
    <div id="theme-my-play-hist-header" />
    <div id="theme-my-play-hist-leftside" />
    <div id="theme-my-play-hist-content" />
    <div id="theme-my-play-hist-rightside" />
    <div id="theme-my-play-hist-footer" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'my-play-hist',
      parts: [
        {
          elem: '#theme-my-play-hist-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-my-play-hist-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-my-play-hist-content',
          htmlFile: 'content'
        },
        {
          elem: '#theme-my-play-hist-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-my-play-hist-footer',
          htmlFile: 'footer'
        }
      ]
    }
  }
}
</script>

<style scoped>
.my-play-hist-template {
  min-height: 100px;
  margin-top: -35px;
}
</style>
